import { IconInterface } from '../../interfaces/icon.interface';

export const ContractsRedSmall = (props: IconInterface) => {
	const { color = '#F44A77', width = 25, height = 25 } = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.4797 13.2787L23.101 10.9601C23.8263 8.25361 24.189 6.90035 23.9159 5.72924C23.7002 4.80455 23.2152 3.96456 22.5221 3.31549C21.6443 2.49345 20.2908 2.13085 17.5839 1.40564C14.877 0.680428 13.5236 0.317823 12.3523 0.590888C11.4275 0.806496 10.5874 1.29147 9.93821 1.98447C9.2343 2.73593 8.86722 3.83601 8.32097 5.83557C8.22922 6.17142 8.13241 6.53265 8.02811 6.92186L8.02809 6.92193L7.40674 9.24051C6.68143 11.947 6.31877 13.3003 6.59188 14.4714C6.80752 15.3961 7.29255 16.2361 7.98566 16.8852C8.86346 17.7072 10.2169 18.0698 12.9238 18.795L12.9238 18.795C15.3636 19.4487 16.7039 19.8077 17.8023 19.6723C17.9225 19.6574 18.0399 19.6367 18.1554 19.6098C19.0803 19.3941 19.9204 18.9092 20.5695 18.2162C21.3917 17.3385 21.7543 15.9852 22.4797 13.2787Z"
				fill={color}
				fillOpacity="0.1"
				stroke={color}
			/>
			<path
				d="M18.1623 8.27777L11.9222 11.7584M13.3017 6.89843L16.7828 13.1376"
				stroke={color}
				strokeLinecap="round"
			/>
			<path
				d="M17.8031 19.6726C17.5529 20.4389 17.1128 21.1322 16.5211 21.6863C15.6433 22.5083 14.2899 22.8709 11.583 23.5961C8.87606 24.3213 7.52261 24.6839 6.35133 24.4109C5.42651 24.1953 4.5864 23.7103 3.93723 23.0173C3.11508 22.1396 2.75243 20.7864 2.02711 18.0798L1.40576 15.7613C0.680453 13.0547 0.317797 11.7015 0.5909 10.5304C0.806539 9.60567 1.29158 8.76568 1.98468 8.11661C2.86248 7.29457 4.21593 6.93196 6.92283 6.20676C7.43494 6.06955 7.89861 5.94533 8.32177 5.83594"
				stroke={color}
			/>
		</svg>
	);
};
